// extracted by mini-css-extract-plugin
module.exports = {"xlarge":"Icon_xlarge_15_oQ","large":"Icon_large_3ORdi","medium":"Icon_medium_k9Deh","small":"Icon_small_3X4Z7","xsmall":"Icon_xsmall_31St_"};